module.exports = __webpack_public_path__ + "static/media/jialishan.06798925.png";